module.exports = "query GetSendableCard($id: ID!) {\n  sendableCard(id: $id) {\n    ...DetailedSendableCardFragment\n  }\n}\n"